import { useEffect } from 'react'
import Card from '@material-ui/core/Card'
import CardContent from '@material-ui/core/CardContent'
import { Title } from 'react-admin'

const NotFound = () => {
  useEffect(() => {
    return () => {
      // Remove the sidebar
      const sidebar = document.querySelectorAll('[class*=RaSidebar-root]')
      if (sidebar[0]) sidebar[0].parentNode.removeChild(sidebar[0])
      const header = document.getElementsByTagName('header')
      if (header[0]) header[0].parentNode.removeChild(header[0])
      const container = document.getElementsByClassName('RaLayout-appFrame')
      if (container[0]) container[0].classList.remove('RaLayout-appFrame')
    }
  })

  return (
    <Card>
      <Title title="Not Found" />
      <CardContent>
        <h1>404: Page not found</h1>
      </CardContent>
    </Card>
  )
}

export default NotFound
